export const statsData = {
  badge: "HOW IT WORKS",
  headline: "More Bookings. Less Burnout.",
  description:
    "You shouldn't have to choose between growing your practice and keeping your sanity. Ascencio Group does the heavy lifting so you get more bookings, better retention, and predictable revenue every month.",
  description2:
    "Our strategy is simple: We only win when you win. Our pure performance-based model means that if you don't get paid, we don't get paid. We are your partners in growth. We support ambitious clinics in ascending to their full potential.",
  ctaButton: {
    text: "See Solutions",
    link: "/services",
  },
  stats: [
    {
      number: 1400,
      suffix: "+",
      label: "Confirmed Bookings",
    },
    {
      number: 4,
      suffix: "+",
      label: "Years Experience",
    },
    {
      number: 85,
      suffix: "%",
      label: "Success Rate",
    },
    {
      number: 24,
      suffix: "/7",
      label: "Support Available",
    },
  ],
  funnel: [
    {
      iconName: "Target",
      title: "Targeted Ads",
      description: "Precision campaigns reaching patients ready to book now.",
    },
    {
      iconName: "UserCheck",
      title: "Vetting & Qualifying",
      description:
        "Our fully trained appointment setters speak to all inquiries, qualifies patients and filters out time-wasters.",
    },
    {
      iconName: "CalendarCheck",
      title: "Confirmed Bookings",
      description:
        "Appointments are secured with deposits paid directly to you.",
    },
    {
      iconName: "Star",
      title: "Reputation Building",
      description:
        "We manage reschedules and collect patient feedback to strengthen your reviews.",
    },
  ],
};
